module.exports = __webpack_public_path__ + "img/ACT.31dc85f5.svg";